<template>
  <div class="app-container">
    <!-- 顶部导航 -->
    <Header :is-full-screen="isFullScreen" @toggle-full-screen="toggleFullScreen" />

    <!-- 主内容区 -->
    <main class="p-3 grid grid-cols-12 gap-6">
      <!-- 左侧设备列表 -->
      <DeviceList @select-device="selectDevice" />

      <!-- 中间设备布局图 -->
      <DeviceLayout :selected-device-id="selectedDevice" :class="selectedDeviceClass" />

      <!-- 右侧数据监控 -->
      <!-- <DataMonitoring v-if="selectedDevice === 'xuefengshan' || selectedDevice === 'city'" /> -->
      <Budian v-if="selectedDevice === 'xuefengshan' || selectedDevice === 'city'" />
    </main>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import DeviceList from '@/components/DeviceList.vue';
import DeviceLayout from '@/components/DeviceLayout.vue';
// import DataMonitoring from '@/components/DataMonitoring.vue';
import Budian from '@/components/Budian.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'MonitoringView',
  components: {
    Header,
    DeviceList,
    DeviceLayout,
    // DataMonitoring,
    Budian,
    Footer
  },
  data() {
    return {
      selectedDevice: 'xuefengshan',
      isFullScreen: false
    };
  },
  computed: {
    selectedDeviceClass() {
      return {
        'col-span-6': this.selectedDevice === 'xuefengshan' || this.selectedDevice === 'city',
        'col-span-10': this.selectedDevice !== 'xuefengshan' && this.selectedDevice !== 'city'
      };
    }
  },
  mounted() {
    const handleFullScreenChange = () => {
      this.isFullScreen = !!document.fullscreenElement;
    };

    document.addEventListener('fullscreenchange', handleFullScreenChange);
    this.fullScreenChangeHandler = handleFullScreenChange;
  },
  beforeDestroy() {
    // 移除全屏事件监听器
    if (this.fullScreenChangeHandler) {
      document.removeEventListener('fullscreenchange', this.fullScreenChangeHandler);
    }
  },
  methods: {
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(err => {
          console.error('Error attempting to enable full-screen mode:', err);
        });
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },
    selectDevice(deviceId) {
      this.selectedDevice = deviceId;
    }
  }
};
</script>

<style>
/* 全局高度设置 */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
/* 全局样式重置 */
:root {
  box-sizing: border-box;
  font-size: 12.8px;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

.app-container {
  height: 100vh;
  width: 100vw;
  transform-origin: top left;
  background-color: #1d2129;
  color: #f2f3f5;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

header {
  flex-shrink: 0;
}

main {
  flex-grow: 1;
  overflow-y: auto;
}

/* 修复全屏滚动条问题 */
.app-container:-webkit-full-screen {
  height: 100%;
  overflow: hidden;
}

.app-container:-moz-full-screen {
  height: 100%;
  overflow: hidden;
}

:fullscreen .app-container,
html:fullscreen .app-container,
:-webkit-full-screen .app-container,
:-moz-full-screen .app-container {
  height: 100% !important;
  overflow: hidden !important;
}

/* 确保全屏时根元素无滚动条 */
:fullscreen,
html:fullscreen,
:-webkit-full-screen,
:-moz-full-screen,
:fullscreen body,
html:fullscreen body,
:-webkit-full-screen body,
:-moz-full-screen body {
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  scrollbar-width: none !important; /* Firefox */
}

/* Chrome, Safari 和 Edge */
:fullscreen body::-webkit-scrollbar,
html:fullscreen body::-webkit-scrollbar,
:-webkit-full-screen body::-webkit-scrollbar {
  display: none !important;
}

/* 全屏状态样式 */
.app-container:fullscreen {
  height: 100%;
  padding: 0;
}

.app-container:fullscreen header,
.app-container:fullscreen main {
  padding: 1rem;
}

.device-list {
  flex-grow: 1;
  overflow-y: auto;
}

/* 修复全屏时的滚动条问题 */
html:fullscreen body,
html:-webkit-full-screen body,
html:-moz-full-screen body {
  overflow: hidden;
  height: 100%;
}

.app-container:fullscreen main {
  padding: 1rem;
}

/* 修复全屏时的滚动条问题 */
:fullscreen,
:fullscreen body {
  overflow: hidden;
  height: 100%;
}

/* 兼容不同浏览器的全屏样式 */
:-webkit-full-screen {
  overflow: hidden;
}

:-moz-full-screen {
  overflow: hidden;
}

/* 工具类样式 - 从demo.html迁移 */
.datav-border {
  border: 1px solid rgba(22, 93, 255, 0.3);
  box-shadow: 0 0 15px rgba(22, 93, 255, 0.1);
}

.datav-gradient {
  background: linear-gradient(
    135deg,
    rgba(22, 93, 255, 0.1) 0%,
    rgba(15, 198, 194, 0.05) 100%
  );
}

.point-normal {
  background-color: #0fc6c2;
  box-shadow: 0 0 0.78125rem rgba(15, 198, 194, 0.8);
}

.point-warning {
  background-color: #ff7d00;
  box-shadow: 0 0 0.78125rem rgba(255, 125, 0, 0.8);
}

.point-alarm {
  background-color: #f53f3f;
  box-shadow: 0 0 0.78125rem rgba(245, 63, 63, 0.8);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

/* 设备项激活状态 */
.device-item.active {
  background-color: rgba(22, 93, 255, 0.1);
  border-left: 2px solid #165dff;
}
</style>